var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3121_3820)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3121_3820",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 5.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3121_3820)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5484 12.4638C13.8206 12.5596 14.1103 12.5954 14.3975 12.5687C14.6848 12.542 14.9629 12.4535 15.2128 12.3092C15.4626 12.1649 15.6783 11.9682 15.845 11.7327C16.0117 11.4972 16.1254 11.2284 16.1784 10.9448L16.4984 9.22481C17.8142 8.92506 19.1806 8.92506 20.4964 9.22481L20.8184 10.9448C20.8715 11.2284 20.9852 11.4972 21.1519 11.7327C21.3186 11.9682 21.5343 12.1649 21.7841 12.3092C22.0339 12.4535 22.3121 12.542 22.5993 12.5687C22.8866 12.5954 23.1763 12.5596 23.4484 12.4638L25.0974 11.8838C26.0153 12.8726 26.6992 14.0551 27.0984 15.3438L25.7684 16.4838C25.5494 16.6716 25.3736 16.9045 25.253 17.1666C25.1325 17.4287 25.07 17.7138 25.07 18.0023C25.07 18.2908 25.1325 18.5759 25.253 18.838C25.3736 19.1001 25.5494 19.333 25.7684 19.5208L27.0984 20.6598C26.6992 21.9485 26.0153 23.131 25.0974 24.1198L23.4474 23.5398C23.1753 23.444 22.8856 23.4082 22.5983 23.4349C22.3111 23.4616 22.0329 23.5502 21.7831 23.6945C21.5333 23.8388 21.3176 24.0354 21.1509 24.2709C20.9842 24.5064 20.8705 24.7752 20.8174 25.0588L20.4984 26.7788C19.1826 27.0786 17.8162 27.0786 16.5004 26.7788L16.1784 25.0588C16.1254 24.7752 16.0117 24.5064 15.845 24.2709C15.6783 24.0354 15.4626 23.8388 15.2128 23.6945C14.9629 23.5502 14.6848 23.4616 14.3975 23.4349C14.1103 23.4082 13.8206 23.444 13.5484 23.5398L11.8994 24.1198C10.9815 23.131 10.2977 21.9485 9.89844 20.6598L11.2284 19.5198C11.4473 19.332 11.623 19.0992 11.7434 18.8372C11.8639 18.5751 11.9263 18.2902 11.9263 18.0018C11.9263 17.7134 11.8639 17.4285 11.7434 17.1665C11.623 16.9044 11.4473 16.6716 11.2284 16.4838L9.89844 15.3438C10.2974 14.0552 10.9809 12.8727 11.8984 11.8838L13.5484 12.4638ZM18.4984 15.0018C19.2941 15.0018 20.0571 15.3179 20.6198 15.8805C21.1824 16.4431 21.4984 17.2062 21.4984 18.0018C21.4984 18.7975 21.1824 19.5605 20.6198 20.1231C20.0571 20.6857 19.2941 21.0018 18.4984 21.0018C17.7028 21.0018 16.9397 20.6857 16.3771 20.1231C15.8145 19.5605 15.4984 18.7975 15.4984 18.0018C15.4984 17.2062 15.8145 16.4431 16.3771 15.8805C16.9397 15.3179 17.7028 15.0018 18.4984 15.0018Z",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3121_3820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.6c6bd234083a702cee60d512ffab5ab3.svg";
export { ForwardRef as ReactComponent };